import { Option } from 'baseui/select'

import { WemoloMenuOption } from '../../../components/Wemolo'
import { LotType } from '../lot-types'

export const transformLotToMenuOption = (lot: LotType): WemoloMenuOption => ({
    value: lot.id,
    label: lot.id
})
export const transformSelectValueToLotType = (selectValue: Option | undefined | null): LotType | null => {
    if (!selectValue) {
        return null
    }

    return {
        __typename: 'lot',
        id: selectValue.id ? selectValue.id.toString() : ''
    }
}
